import { Mesh, MeshBasicMaterial, RingGeometry, Vector3 } from 'three';

/*
 *  Creates a simple circular marker mesh to overlay on scanned planes.
 */
export function createPlaneMarker() {
  const planeMarkerMaterial = new MeshBasicMaterial({ color: 0xffffff });

  const planeMarkerGeometry = new RingGeometry(0.14, 0.15, 100).rotateX(-Math.PI / 2);

  const planeMarker = new Mesh(planeMarkerGeometry, planeMarkerMaterial);
  planeMarker.name = 'marker';

  planeMarker.matrixAutoUpdate = false;

  return planeMarker;
}
